module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/banner/id-a2fb13f87bc1c63156b83fac32beeeba.jpg";